import { saveAs } from "file-saver";

export async function downloadLotteryCSV(report) {
  const ExcelJS = (await import("exceljs")).default;

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Сугалааны товч тайлан");

  const border = { style: "thin", color: { argb: "FFBFBFBF" } };
  const setBorder = (c) =>
    (c.border = { top: border, left: border, bottom: border, right: border });
  const center = { horizontal: "center", vertical: "middle" };
  const money = "#,##0.00;[Red]-#,##0.00";

  // ===== 1) ДЭЭД БҮЛЭГ — 3 МЕРЖ ХЭСЭГ =====
  // A1:O1 → Сугалааны мэдээлэл (14 col)
  ws.mergeCells("A1:O1");
  ws.getCell("A1").value = "Сугалааны мэдээлэл";
  ws.getCell("A1").alignment = center;
  ws.getCell("A1").font = { bold: true };
  ws.getCell("A1").border = {
    right: {
      style: "thin",
      color: { argb: "FF808080" },
    },
  };
  ws.getCell("A1").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFE0E0E0" },
  };

  // P1:R1 → Борлогдсон сугалаа (3 col)
  ws.mergeCells("P1:R1");
  ws.getCell("P1").value = "Борлогдсон сугалаа";
  ws.getCell("P1").alignment = center;
  ws.getCell("P1").font = { bold: true };
  ws.getCell("P1").border = {
    right: {
      style: "thin",
      color: { argb: "FF808080" },
    },
  };
  ws.getCell("P1").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFE0E0E0" },
  };

  // S1:U1 → Борлогдоогүй сугалаа (3 col)
  ws.mergeCells("S1:U1");
  ws.getCell("S1").value = "Борлогдоогүй сугалаа";
  ws.getCell("S1").alignment = center;
  ws.getCell("S1").font = { bold: true };
  ws.getCell("S1").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFE0E0E0" },
  };

  // ===== 2) ТОЛГОЙ МӨР =====
  const header = [
    "",
    "Төрөл",
    "Шагнал",
    "Код",
    "Үүсгэсэн огноо",
    "Код 1",
    "Код 2",
    "Үнэ",
    "Ширхэг",
    "Нийт үнэ",
    "Шагнал",
    "Шагнал мөнгөн дүн",
    "Тохирол",
    "Огноо эхэлсэн",
    "Огноо дууссан",
    // sold
    "Сугалааны тоо",
    "Мөнгөн дүн",
    "НӨАТ",
    // unsold
    "Сугалааны тоо",
    "Мөнгөн дүн",
    "Үүсгэсэн хүн",
  ];
  ws.addRow(header);
  const headRow = ws.getRow(2);
  headRow.eachCell((c) => {
    c.font = { bold: true };
    c.alignment = center;
    c.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD9D9D9" },
    };
    setBorder(c);
  });

  // ===== 3) ӨГӨГДӨЛ =====
  const rows = Array.isArray(report?.rows) ? report.rows : [];
  rows.forEach((r, idx) => {
    const row = ws.addRow([
      idx + 1, // ✅ №
      r?.type ?? "Сугалаа",
      r?.prize ?? "",
      r?.code ?? "",
      r?.created_at ?? "",
      r?.code1 ?? "",
      r?.code2 ?? "",
      num(r?.price),
      num(r?.qty),
      num(r?.total),
      r?.prize_name ?? "",
      num(r?.prize_amount),
      r?.draw ?? "",
      r?.start_at ?? "",
      r?.end_at ?? "",
      // sold
      num(r?.sold_count),
      num(r?.sold_amount),
      num(r?.sold_vat),
      // unsold
      num(r?.unsold_count),
      num(r?.unsold_amount),
      r?.created_by ?? "",
    ]);

    // формат
    row.getCell(8).numFmt = money; // Үнэ (A=1 тул 1-ээр урагшилсан)
    // row.getCell(9).numFmt  = "#,##0"; // Ширхэг (хэрэв хэрэгтэй бол)
    row.getCell(10).numFmt = money; // Нийт үнэ
    row.getCell(12).numFmt = money; // Шагнал мөнгөн дүн
    row.getCell(17).numFmt = money; // Борлогдсон - мөнгөн дүн
    row.getCell(18).numFmt = money; // НӨАТ
    row.getCell(20).numFmt = money; // Борлогдоогүй - мөнгөн дүн

    // №-г төвлөрүүлэх
    row.getCell(1).alignment = center;

    row.eachCell((c) => setBorder(c));
  });
  //   for (const r of rows) {
  //     const row = ws.addRow([
  //       r?.type ?? "Сугалаа",
  //       r?.prize ?? "",
  //       r?.code ?? "",
  //       r?.created_at ?? "",
  //       r?.code1 ?? "",
  //       r?.code2 ?? "",
  //       num(r?.price),
  //       num(r?.qty),
  //       num(r?.total),
  //       r?.prize_name ?? "",
  //       num(r?.prize_amount),
  //       r?.draw ?? "",
  //       r?.start_at ?? "",
  //       r?.end_at ?? "",
  //       // sold
  //       num(r?.sold_count),
  //       num(r?.sold_amount),
  //       num(r?.sold_vat),
  //       // unsold
  //       num(r?.unsold_count),
  //       num(r?.unsold_amount),
  //       r?.created_by ?? "",
  //     ]);

  //     // тоон формат
  //     row.getCell(7).numFmt = money; // Үнэ
  //     // row.getCell(8).numFmt = "#,##0"; // Ширхэг
  //     row.getCell(9).numFmt = money; // Нийт үнэ
  //     row.getCell(11).numFmt = money; // Шагнал мөнгөн дүн
  //     row.getCell(16).numFmt = money; // Борлогдсон - мөнгөн дүн
  //     row.getCell(17).numFmt = money; // НӨАТ
  //     row.getCell(19).numFmt = money; // Борлогдоогүй - мөнгөн дүн

  //     row.eachCell((c) => setBorder(c));
  //   }

  // ===== 4) БАГАНЫН ӨРГӨН =====
  const widths = {
    A: 6, // №
    B: 12,
    C: 14,
    D: 10,
    E: 18,
    F: 18,
    G: 10,
    H: 12,
    I: 10,
    J: 18,
    K: 20,
    L: 20,
    M: 18,
    N: 16,
    O: 16,
    P: 16, // sold
    Q: 18,
    R: 14,
    S: 16, // unsold
    T: 16,
    U: 16,
  };
  Object.entries(widths).forEach(([col, w]) => (ws.getColumn(col).width = w));

  // ===== 5) ФАЙЛ ТАТАХ =====
  const buf = await wb.xlsx.writeBuffer();
  const now = new Date();
  const ts = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}${String(now.getDate()).padStart(2, "0")}-${String(now.getHours()).padStart(
    2,
    "0"
  )}${String(now.getMinutes()).padStart(2, "0")}${String(
    now.getSeconds()
  ).padStart(2, "0")}`;
  const filename = `${report?.meta?.ticket_prefix || "LOTTERY"}-${ts}.xlsx`;

  saveAs(
    new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    filename
  );

  function num(v) {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }
}
